import request from '../services/request';

const model = 'admin';

export function requestLogin(data) {
  return request({
    url: `/${model}/login`,
    method: 'POST',
    data,
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export function requestLogout() {
  return request({
    url: `/${model}/logout`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export function validateCodeAuth(data) {
  return request({
    url: `/${model}/validate/auth`,
    method: 'POST',
    data,
  });
}

export function validateCodeRecovery(data) {
  return request({
    url: `/${model}/validate/recovery`,
    method: 'POST',
    data,
  });
}

export function resendCode(data) {
  return request({
    url: `/${model}/validate/resend`,
    method: 'POST',
    data,
  });
}

export function recoveryPassword(data) {
  return request({
    url: `/${model}/recovery`,
    method: 'POST',
    data,
  });
}

export function validateMagicXchg(data) {
  return request({
    url: `/${model}/magic/exchange`,
    method: 'POST',
    data,
  });
}
